module.exports = __webpack_public_path__ + "img/pool.ac62ddae.svg";